module.exports = __webpack_public_path__ + "img/migration.6710482c.jpg";